import { render, staticRenderFns } from "./result.vue?vue&type=template&id=1df4f158&scoped=true&"
import script from "../assets/js/result.js?vue&type=script&lang=js&"
export * from "../assets/js/result.js?vue&type=script&lang=js&"
import style0 from "../assets/css/result.css?vue&type=style&index=0&id=1df4f158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4f158",
  null
  
)

export default component.exports